import injectSheet from 'react-jss';

import FlowRateChart from './component';
import styles from './styles';

export default injectSheet(styles)(FlowRateChart);
